const e = "_wrapper_med2l_1", c = "_heading_med2l_6", _ = "_checkboxWrapper_med2l_11", r = "_vertical_med2l_19", t = "_horizontal_med2l_22", l = "_error_med2l_26", o = "_inputLabelWrapper_med2l_31", a = "_label_med2l_36", n = "_checkbox_med2l_11", p = "_checked_med2l_58", d = "_checkmark_med2l_61", h = "_text_med2l_68", s = "_input_med2l_31", m = {
  wrapper: e,
  heading: c,
  checkboxWrapper: _,
  vertical: r,
  horizontal: t,
  error: l,
  inputLabelWrapper: o,
  label: a,
  checkbox: n,
  checked: p,
  checkmark: d,
  text: h,
  input: s
};
export {
  n as checkbox,
  _ as checkboxWrapper,
  p as checked,
  d as checkmark,
  m as default,
  l as error,
  c as heading,
  t as horizontal,
  s as input,
  o as inputLabelWrapper,
  a as label,
  h as text,
  r as vertical,
  e as wrapper
};
